import React from "react";
import Hero from "./Hero";

function App() {
  return (
    <>
      <Hero />
    </>
  );
}

export default App;
